export default class ChiefModule {
    static empty() {
        return {
            client: {
                politician: false,
                iin: null,
                surname: null,
                name: null,
                patronymic: null,
                birthday: null,
                sex: 1,
                phone: null,
                email: null,
            },
            filter: {
                resident: true,
                person  : true,
                verify  : true,
            },
            document: {
                type_id: 1,
                number: null,
                issued: null,
            },
            location: {
                country_id: null,
                address:    null
            }
        }
    }
    static fieldsSettings(step) {
        const data = {
            4: { // Лидер резидент
                economics_sector_id: { required: false, show: false, disabled:false },
                activity_kind_id:    { required: false, show: false, disabled:false },
                patronymic:          { required: false, show: true,  disabled:false },
                birthday:            { required: true,  show: true,  disabled:false },
                surname:             { required: true,  show: true,  disabled:false },
                email:               { required: false, show: true,  disabled:false },
                phone:               { required: true,  show: true,  disabled:false },
                name:                { required: true,  show: true,  disabled:false },
                iin:                 { required: true,  show: true,  disabled:false },
                sex:                 { required: true,  show: true,  disabled:false },
                // Document
                type_id:             { required: true,  show: true,  disabled:false },
                issued:              { required: true,  show: true,  disabled:false },
                number:              { required: true,  show: true,  disabled:false },
                issuer:              { required: true,  show: true,  disabled:false },
                until:               { required: false, show: true,  disabled:false },
                // Address
                country_id:          { required: false, show: false, disabled:false },
                address:             { required: false, show: true,  disabled:false }
            },
            5: { // Лидер нерезидент
                economics_sector_id: { required: false, show: false, disabled:false },
                activity_kind_id:    { required: false, show: false, disabled:false },
                patronymic:          { required: false, show: true,  disabled:false },
                birthday:            { required: true,  show: true,  disabled:false },
                surname:             { required: true,  show: true,  disabled:false },
                email:               { required: false, show: true,  disabled:false },
                phone:               { required: false, show: true,  disabled:false },
                name:                { required: true,  show: true,  disabled:false },
                iin:                 { required: false, show: true,  disabled:false },
                sex:                 { required: true,  show: true,  disabled:false },
                // Document
                type_id:             { required: true,  show: true,  disabled:false },
                issued:              { required: true,  show: true,  disabled:false },
                number:              { required: true,  show: true,  disabled:false },
                issuer:              { required: true,  show: true,  disabled:false },
                until:               { required: false, show: true,  disabled:false },
                // Address
                country_id:          { required: true,  show: true,  disabled:false },
                address:             { required: false, show: true,  disabled:false }
            },
            6: { // Собственник резидент
                economics_sector_id: { required: false, show: false, disabled:false },
                activity_kind_id:    { required: false, show: false, disabled:false },
                patronymic:          { required: false, show: true,  disabled:false },
                birthday:            { required: true,  show: true,  disabled:false },
                surname:             { required: true,  show: true,  disabled:false },
                email:               { required: false, show: true,  disabled:false },
                phone:               { required: true,  show: true,  disabled:false },
                name:                { required: true,  show: true,  disabled:false },
                iin:                 { required: true,  show: true,  disabled:false },
                sex:                 { required: true,  show: true,  disabled:false },
                // Document
                type_id:             { required: true,  show: true,  disabled:false },
                issued:              { required: true,  show: true,  disabled:false },
                number:              { required: true,  show: true,  disabled:false },
                issuer:              { required: true,  show: true,  disabled:false },
                until:               { required: false, show: true,  disabled:false },
                // Address
                country_id:          { required: false, show: false, disabled:false },
                address:             { required: false, show: true,  disabled:false }
            },
            7: { // Собственник нерезидент
                economics_sector_id: { required: false, show: false, disabled:false },
                activity_kind_id:    { required: false, show: false, disabled:false },
                patronymic:          { required: false, show: true,  disabled:false },
                birthday:            { required: true,  show: true,  disabled:false },
                surname:             { required: true,  show: true,  disabled:false },
                email:               { required: false, show: true,  disabled:false },
                phone:               { required: false, show: true,  disabled:false },
                name:                { required: true,  show: true,  disabled:false },
                iin:                 { required: false, show: true,  disabled:false },
                sex:                 { required: true,  show: true,  disabled:false },
                // Document
                type_id:             { required: true,  show: true,  disabled:false },
                issued:              { required: true,  show: true,  disabled:false },
                number:              { required: true,  show: true,  disabled:false },
                issuer:              { required: true,  show: true,  disabled:false },
                until:               { required: false, show: true,  disabled:false },
                // Address
                country_id:          { required: true,  show: true,  disabled:false },
                address:             { required: false, show: true,  disabled:false }
            }
        }

        return data[step]
    }
    static documentType(step) {
        const documentTypes = {
            0: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
            1: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
            default: {7: 'Свидетельство о государственной регистрации (перерегистрации) юридического лица'}
        };

        return documentTypes[step] || documentTypes.default;
    }
}
